const carouselItems = [
  {
    title: '触手都市专题',
    desc: '探索现代都市中隐藏的触手秘密',
    tag: '都市奇幻',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20manga-style%20illustration%20of%20a%20mysterious%20urban%20cityscape%20at%20dusk%20with%20shadowy%20tentacle%20forms%20emerging%20from%20buildings%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20atmospheric%20noir%20aesthetic%2C%20warm%20amber%20and%20deep%20coral%20color%20palette%2C%20cinematic%20widescreen%20composition&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    title: '异界触手录专题',
    desc: '穿越异世界的触手力量觉醒之旅',
    tag: '异世界冒险',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20fantasy%20manga%20illustration%20of%20a%20magical%20portal%20opening%20in%20a%20lush%20forest%20with%20glowing%20tentacle-like%20energy%20streaming%20out%2C%20ancient%20ruins%2C%20sparkling%20magical%20particles%2C%20warm%20golden%20and%20coral%20lighting%2C%20epic%20adventure%20atmosphere&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    title: '触手纪元专题',
    desc: '科幻机甲与触手科技的史诗碰撞',
    tag: '科幻机甲',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20sci-fi%20manga%20illustration%20of%20a%20futuristic%20city%20with%20giant%20mechas%20and%20organic%20tentacle-like%20structures%20integrated%20into%20architecture%2C%20holographic%20advertisements%2C%20flying%20vehicles%2C%20warm%20copper%20and%20coral%20metallic%20tones%2C%20cyberpunk%20aesthetic&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    title: '触手学园专题',
    desc: '校园里的触手伙伴温馨日常故事',
    tag: '校园搞笑',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20manga%20illustration%20of%20a%20bright%20sunny%20school%20campus%20with%20students%20playing%20with%20friendly%20cartoonish%20tentacle%20creatures%2C%20cherry%20blossom%20trees%2C%20warm%20spring%20lighting%2C%20pastel%20coral%20and%20cream%20color%20palette%2C%20cheerful%20slice-of-life%20atmosphere&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    title: '暗夜触手专题',
    desc: '深夜校园中的悬疑触手谜团',
    tag: '悬疑惊悚',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20horror%20manga%20illustration%20of%20an%20abandoned%20school%20building%20under%20moonlight%20with%20eerie%20tentacle%20shadows%20spreading%20across%20the%20walls%2C%20foggy%20atmosphere%2C%20dark%20red%20and%20deep%20amber%20tones%2C%20suspenseful%20thriller%20cinematic%20composition&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 scroll-mt-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          触手漫画精选专题，深度探索每一部佳作
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group relative h-64 md:h-72 lg:h-80 rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={item.image}
                alt={`${item.title} - 触手漫画焦点专题`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-bold text-background-50 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-background-50/80">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}